import { render, staticRenderFns } from "./part_ten.vue?vue&type=template&id=b6ff7bd8&scoped=true"
import script from "./part_ten.vue?vue&type=script&lang=js"
export * from "./part_ten.vue?vue&type=script&lang=js"
import style0 from "./part_ten.vue?vue&type=style&index=0&id=b6ff7bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ff7bd8",
  null
  
)

export default component.exports